import axios from "axios";
import { affiliates } from "../../common/enums/affiliates";
import { analyticsConstants } from "../../common/constants/analytics";
import { GtagService } from "./gtag/gtag.service";
import { GtmService } from "./gtm/gtm.service";
import { Relay42Service } from "./relay42/relay42.service";
import { GetApiUrl } from "../general.service";
import { httpRequestMethods } from "../../common/enums/httpRequestMethods";

const init = () => {
    GtagService.init();

    if (process.env.REACT_APP_AFFILIATE === affiliates.klm) {
        Relay42Service.initRelay42forKLM(affiliates.klm);
    }
    else if (process.env.REACT_APP_AFFILIATE === affiliates.transavia) {
        GtmService.initGoogleTagManagerForTransavia(affiliates.transavia);
    }
};

const getApiPath = (eventName) => {
    return analyticsConstants.apiPaths[eventName];
};

const getAnalyticsData = async (events) => {
    const eventName = events.find(e => e)?.name;
    const eventData = events.find(e => e)?.data;
    if (eventName && eventData) {
        const requestUrl = GetApiUrl() + getApiPath(eventName);
        const isPostRequest = (eventData instanceof Object) ? true : false;
        const axiosConfig = {
            method: isPostRequest ? httpRequestMethods.POST : httpRequestMethods.GET,
            url: `${requestUrl}${isPostRequest ? "" : eventData}`,
            data: eventData,
        };
        const analyticsData = await axios.request(axiosConfig);
        return analyticsData;
    }
    else return null;
}

const handleEvents = async (events) => {
    const analyticsData = await getAnalyticsData(events);
    if (analyticsData) {
        for (const event of events) {
            switch (event.platform) {
                case analyticsConstants.platform.gtag:
                    GtagService.eventTrigger(event, analyticsData);
                    break;
                case analyticsConstants.platform.gtmRelay42:
                    handleEventForGtmAndRelay42(event, analyticsData);
                    break;
                default:
                    console.error(analyticsConstants.platform.unknown);
            }
        }
    }
}

const handleEventForGtmAndRelay42 = (event, analyticsData) => {
    switch (process.env.REACT_APP_AFFILIATE) {
        case (affiliates.klm):
            Relay42Service?.eventTrigger(event, analyticsData);
            break;
        case (affiliates.transavia):
            GtmService?.eventTrigger(event, analyticsData);
            break;
        default:
            console.error(analyticsConstants.affiliates.unknown);
    }
}

export const AnalyticsService = {
    analyticsConstants: analyticsConstants,
    init: init,
    handleEvents: handleEvents
}